var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { status } from "@spike/appointment-model";
import { getYesterdayAsYMD } from "@spike/date-utils";
import { showError, showSuccess, } from "@spike/notifications-action";
import axios from "axios";
import { BOOKINGS_ASSIGN_STAFF_ACTION_TYPE, BOOKINGS_CANCEL_SEVERAL_LOCAL_ACTION_TYPE, BOOKINGS_CANCEL_START_ACTION_TYPE, BOOKINGS_CANCEL_SUCCESS_ACTION_TYPE, BOOKINGS_CONFIRM_APPOINTMENT_START_ACTION_TYPE, BOOKINGS_CONFIRM_APPOINTMENT_SUCCESS_ACTION_TYPE, BOOKINGS_CONFIRM_START_ACTION_TYPE, BOOKINGS_CONFIRM_SUCCESS_ACTION_TYPE, BOOKINGS_DELETE_START_ACTION_TYPE, BOOKINGS_DELETE_SUCCESS_ACTION_TYPE, BOOKINGS_ERROR_ACTION_TYPE, BOOKINGS_FETCH_CLIENT_PENDINGS_START_ACTION_TYPE, BOOKINGS_FETCH_CLIENT_PENDINGS_SUCCESS_ACTION_TYPE, BOOKINGS_FETCH_CLIENT_START_ACTION_TYPE, BOOKINGS_FETCH_CLIENT_SUCCESS_ACTION_TYPE, BOOKINGS_FETCH_CLIENT_WITH_STAFF_ISSUES_START_ACTION_TYPE, BOOKINGS_FETCH_CLIENT_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE, BOOKINGS_FETCH_PENDINGS_START_ACTION_TYPE, BOOKINGS_FETCH_PENDINGS_SUCCESS_ACTION_TYPE, BOOKINGS_FETCH_START_ACTION_TYPE, BOOKINGS_FETCH_SUCCESS_ACTION_TYPE, BOOKINGS_FETCH_WITH_STAFF_ISSUES_START_ACTION_TYPE, BOOKINGS_FETCH_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE, BOOKINGS_GET_INVOICE_BOOKING_START_ACTION_TYPE, BOOKINGS_GET_INVOICE_BOOKING_SUCCESS_ACTION_TYPE, BOOKINGS_GET_START_ACTION_TYPE, BOOKINGS_GET_SUCCESS_ACTION_TYPE, BOOKINGS_LOCK_END_ACTION_TYPE, BOOKINGS_LOCK_START_ACTION_TYPE, BOOKINGS_REMOVE_LOCAL_ACTION_TYPE, BOOKINGS_REMOVE_SEVERAL_LOCAL_ACTION_TYPE, BOOKINGS_RESET_ACTION_TYPE, BOOKINGS_UNLOCK_START_ACTION_TYPE, BOOKINGS_UNLOCK_SUCCESS_ACTION_TYPE, BOOKINGS_UNLOCK_UNAUTHORIZED_ACTION_TYPE, BOOKINGS_UPDATE_LOCAL_ACTION_TYPE, } from "./BookingsActionsTypes";
import { convertToBooking, convertToLock } from "./BookingsConverter";
var bookingsUrl = "/bookings";
var bookingConfirmUrl = "/booking/confirm";
var appointmentConfirmUrl = "/appointment/confirm";
var bookingCancelUrl = "/booking/cancel";
var bookingsWithStaffIssuesUrl = "/bookings_to_check";
var bookingsWithStaffIssuesCustomerUrl = "/bookings_to_check_by_customer";
var bookingsCustomer = "/bookings_by_customer";
var bookingLockUrl = "/booking/lock";
var bookingUnlockUrl = "/booking/unlock";
var unauthorized = 401;
var locked = 423;
var isLastFetch = function (requestUuid, bookingsState) {
    return bookingsState.lastFetchRequestUuid === requestUuid;
};
var isLastClientFetch = function (requestUuid, bookingsState) {
    return bookingsState.clientBookings.lastFetchRequestUuid === requestUuid;
};
export var refetchBookingsThunk = function (apiClientWrapper) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (getState().bookings.filter.withStaffIssues) {
                dispatch(fetchBookingsWithStaffIssuesThunk(apiClientWrapper));
            }
            else {
                dispatch(fetchBookingsThunk(apiClientWrapper, getState().bookings.filter.from, getState().bookings.filter.to));
            }
            return [2 /*return*/];
        });
    }); };
};
export var refetchClientBookingsThunk = function (apiClientWrapper) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var clientId, from, to, petIds;
        return __generator(this, function (_a) {
            clientId = getState().bookings.clientBookings.filter.clientId;
            from = getState().bookings.clientBookings.filter.from;
            to = getState().bookings.clientBookings.filter.to;
            petIds = getState().bookings.clientBookings.filter.petIds;
            if (clientId) {
                if (getState().bookings.clientBookings.filter.withStaffIssues) {
                    dispatch(fetchClientBookingsWithStaffIssuesThunk(apiClientWrapper, clientId, petIds));
                }
                else {
                    dispatch(fetchClientBookingsThunk(apiClientWrapper, from, to, clientId, petIds));
                }
            }
            return [2 /*return*/];
        });
    }); };
};
export var updateLocalBookingThunk = function (bookingDto, masterData, timeZone) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(updateLocal(convertToBooking(bookingDto, masterData, timeZone)));
            return [2 /*return*/];
        });
    }); };
};
export var removeLocalBookingThunk = function (bookingId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(removeLocal(bookingId));
            return [2 /*return*/];
        });
    }); };
};
export var removeSeveralLocalBookingThunk = function (appointmentIds) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(removeSeveralLocal(appointmentIds));
            return [2 /*return*/];
        });
    }); };
};
export var cancelSeveralLocalBookingThunk = function (appointmentIds, masterData) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(cancelSeveralLocal(appointmentIds, masterData.status.find(function (option) { return option.id === status.CANCELLED; })));
            return [2 /*return*/];
        });
    }); };
};
export var updateLocalBookingByIdThunk = function (apiClientWrapper, bookingId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var bookingDto, apiError_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getBooking(apiClientWrapper, bookingId)];
                case 1:
                    bookingDto = _b.sent();
                    //console.info({action: "Update booking", bookingDto});
                    dispatch(updateLocal(convertToBooking(bookingDto, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 3];
                case 2:
                    apiError_1 = _b.sent();
                    //console.info({action: "Error booking", status: apiError.response?.status, bookingId});
                    ((_a = apiError_1.response) === null || _a === void 0 ? void 0 : _a.status) === 404 && dispatch(removeLocal(bookingId));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchBookingsThunk = function (apiClientWrapper, from, to) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchStart(from, to, requestUuid));
                    url = "".concat(bookingsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&start_date=").concat(from === null ? "" : from, "&end_date=").concat(to === null ? "" : to);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastFetch(requestUuid, getState().bookings) &&
                        dispatch(fetchSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!axios.isCancel(apiError_2)) {
                        dispatch(error());
                        dispatch(showError("Error fetching bookings."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchClientBookingsThunk = function (apiClientWrapper, from, to, clientId, petIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchClientStart(clientId, petIds, from, to, requestUuid));
                    url = "".concat(bookingsCustomer, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId, "&start_date=").concat(from === null ? "" : from, "&end_date=").concat(to === null ? "" : to, "&pet_id=").concat(petIds);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastClientFetch(requestUuid, getState().bookings) &&
                        dispatch(fetchClientSuccess(clientId, petIds, response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!axios.isCancel(apiError_3)) {
                        dispatch(error());
                        dispatch(showError("Error fetching client bookings."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchPendingBookingsThunk = function (apiClientWrapper) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, yesterdayAsString, url, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    yesterdayAsString = getYesterdayAsYMD(apiClientWrapper.timeZone);
                    dispatch(fetchPendingsStart(yesterdayAsString, requestUuid));
                    url = "".concat(bookingsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&end_date=").concat(yesterdayAsString, "&start_date=2020-01-01");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastFetch(requestUuid, getState().bookings) &&
                        dispatch(fetchPendingsSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!axios.isCancel(apiError_4)) {
                        dispatch(error());
                        dispatch(showError("Error fetching pending bookings."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchClientPendingBookingsThunk = function (apiClientWrapper, clientId, petIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, yesterdayAsString, url, response, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    yesterdayAsString = getYesterdayAsYMD(apiClientWrapper.timeZone);
                    dispatch(fetchClientPendingsStart(clientId, petIds, yesterdayAsString, requestUuid));
                    url = "".concat(bookingsCustomer, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId, "&end_date=").concat(yesterdayAsString, "&start_date=2020-01-01&pet_id=").concat(petIds);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastClientFetch(requestUuid, getState().bookings) &&
                        dispatch(fetchClientPendingsSuccess(clientId, petIds, response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    if (!axios.isCancel(apiError_5)) {
                        dispatch(error());
                        dispatch(showError("Error fetching client pending bookings."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchBookingsWithStaffIssuesThunk = function (apiClientWrapper) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchWithStaffIssuesStart(requestUuid));
                    url = "".concat(bookingsWithStaffIssuesUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastFetch(requestUuid, getState().bookings) &&
                        dispatch(fetchWithStaffIssuesSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!axios.isCancel(apiError_6)) {
                        dispatch(error());
                        dispatch(showError("Error fetching bookings with staff issues."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchClientBookingsWithStaffIssuesThunk = function (apiClientWrapper, clientId, petIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchClientWithStaffIssuesStart(clientId, petIds, requestUuid));
                    url = "".concat(bookingsWithStaffIssuesCustomerUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId, "&pet_id=").concat(petIds);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastClientFetch(requestUuid, getState().bookings) &&
                        dispatch(fetchClientWithStaffIssuesSuccess(clientId, petIds, response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    if (!axios.isCancel(apiError_7)) {
                        dispatch(error());
                        dispatch(showError("Error fetching client bookings with staff issues."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getBookingThunk = function (apiClientWrapper, bookingId, context) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var bookingDto, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart(context));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getBooking(apiClientWrapper, bookingId)];
                case 2:
                    bookingDto = _a.sent();
                    dispatch(getSuccess(bookingDto, apiClientWrapper.masterData, apiClientWrapper.timeZone, context));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    if (!axios.isCancel(apiError_8)) {
                        dispatch(error());
                        dispatch(showError("Error getting booking."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var getBooking = function (apiClientWrapper, bookingId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(bookingsUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
export var confirmBookingThunk = function (apiClientWrapper, bookingId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(confirmStart());
                    url = "".concat(bookingConfirmUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, undefined, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(confirmSuccess(convertToBooking(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _a.sent();
                    if (!axios.isCancel(apiError_9)) {
                        dispatch(error());
                        dispatch(showError("Error confirming booking."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var confirmAppointmentThunk = function (apiClientWrapper, appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(confirmAppointmentStart());
                    url = "".concat(appointmentConfirmUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, undefined, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(confirmAppointmentSuccess(convertToBooking(response.data.booking, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    if (!axios.isCancel(apiError_10)) {
                        dispatch(error());
                        dispatch(showError("Error confirming appointment."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var cancelBookingThunk = function (apiClientWrapper, bookingId, sendNotification, cancelationReasonId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(cancelStart());
                    url = "".concat(bookingCancelUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = {
                        send_notification: sendNotification,
                        cancelation_reason_id: cancelationReasonId || null,
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(cancelSuccess(convertToBooking(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    dispatch(showSuccess("Booking canceled."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_11 = _a.sent();
                    if (!axios.isCancel(apiError_11)) {
                        dispatch(error());
                        dispatch(showError("Error canceling booking."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteBookingThunk = function (apiClientWrapper, bookingId, disableAlert) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiError_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteStart(bookingId));
                    url = "".concat(bookingsUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteSuccess(bookingId));
                    !disableAlert && dispatch(showSuccess("Booking deleted."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_12 = _a.sent();
                    if (!axios.isCancel(apiError_12)) {
                        dispatch(error());
                        !disableAlert && dispatch(showError("Error deleting booking."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var lockBookingThunk = function (apiClientWrapper, bookingId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, result, apiError_13;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(lockStart(bookingId));
                    url = "".concat(bookingLockUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, undefined, apiClientWrapper.requestConfig)];
                case 2:
                    result = _d.sent();
                    dispatch(lockEnd(convertToLock(result.data, bookingId)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_13 = _d.sent();
                    if (!axios.isCancel(apiError_13)) {
                        if (axios.isAxiosError(apiError_13) &&
                            [unauthorized, locked].includes((_b = (_a = apiError_13.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 0)) {
                            apiError_13.response
                                ? dispatch(lockEnd(convertToLock(apiError_13.response.data, bookingId)))
                                : dispatch(error());
                        }
                        else {
                            dispatch(error());
                            dispatch(showError("Error locking booking. (".concat((_c = apiError_13.reponse) === null || _c === void 0 ? void 0 : _c.status, ")")));
                            console.info({ apiError: apiError_13 });
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var unlockBookingThunk = function (apiClientWrapper, bookingId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiError_14;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(unlockStart());
                    url = "".concat(bookingUnlockUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, undefined, apiClientWrapper.requestConfig)];
                case 2:
                    _d.sent();
                    dispatch(unlockEnd(bookingId));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_14 = _d.sent();
                    if (!axios.isCancel(apiError_14)) {
                        if (axios.isAxiosError(apiError_14) &&
                            [unauthorized, locked].includes((_b = (_a = apiError_14.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 0)) {
                            dispatch(unlockUnauthorized);
                        }
                        else {
                            dispatch(error());
                            dispatch(showError("Error unlocking booking (".concat((_c = apiError_14.reponse) === null || _c === void 0 ? void 0 : _c.status, ")")));
                            console.info({ apiError: apiError_14 });
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var resetBookings = function () {
    return {
        type: BOOKINGS_RESET_ACTION_TYPE,
    };
};
var fetchStart = function (from, to, requestUuid) {
    return {
        type: BOOKINGS_FETCH_START_ACTION_TYPE,
        payload: {
            from: from,
            to: to,
            requestUuid: requestUuid,
        },
    };
};
var fetchSuccess = function (bookingsResponseDto, masterData, timeZone) {
    return {
        type: BOOKINGS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            bookings: bookingsResponseDto.bookings_to_confirm.map(function (dto) {
                return convertToBooking(dto, masterData, timeZone);
            }),
        },
    };
};
var fetchPendingsStart = function (to, requestUuid) {
    return {
        type: BOOKINGS_FETCH_PENDINGS_START_ACTION_TYPE,
        payload: {
            from: null,
            to: to,
            requestUuid: requestUuid,
        },
    };
};
var fetchPendingsSuccess = function (bookingsResponseDto, masterData, timeZone) {
    return {
        type: BOOKINGS_FETCH_PENDINGS_SUCCESS_ACTION_TYPE,
        payload: {
            bookings: bookingsResponseDto.bookings_to_confirm.map(function (dto) {
                return convertToBooking(dto, masterData, timeZone);
            }),
        },
    };
};
var fetchWithStaffIssuesStart = function (requestUuid) {
    return {
        type: BOOKINGS_FETCH_WITH_STAFF_ISSUES_START_ACTION_TYPE,
        payload: {
            from: null,
            to: null,
            requestUuid: requestUuid,
        },
    };
};
var fetchWithStaffIssuesSuccess = function (bookingsResponseDto, masterData, timeZone) {
    return {
        type: BOOKINGS_FETCH_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE,
        payload: {
            bookings: bookingsResponseDto.bookings_to_check.map(function (dto) {
                return convertToBooking(dto, masterData, timeZone);
            }),
        },
    };
};
var fetchClientStart = function (clientId, petIds, from, to, requestUuid) {
    return {
        type: BOOKINGS_FETCH_CLIENT_START_ACTION_TYPE,
        payload: {
            from: from,
            to: to,
            clientId: clientId,
            petIds: petIds,
            requestUuid: requestUuid,
        },
    };
};
var fetchClientSuccess = function (clientId, petIds, bookingsResponseDto, masterData, timeZone) {
    return {
        type: BOOKINGS_FETCH_CLIENT_SUCCESS_ACTION_TYPE,
        payload: {
            totalBookingsCount: bookingsResponseDto.bookings_count,
            bookings: bookingsResponseDto.bookings_to_confirm.map(function (dto) {
                return convertToBooking(dto, masterData, timeZone);
            }),
            clientId: clientId,
            petIds: petIds,
        },
    };
};
var fetchClientPendingsStart = function (clientId, petIds, to, requestUuid) {
    return {
        type: BOOKINGS_FETCH_CLIENT_PENDINGS_START_ACTION_TYPE,
        payload: {
            clientId: clientId,
            petIds: petIds,
            from: null,
            to: to,
            requestUuid: requestUuid,
        },
    };
};
var fetchClientPendingsSuccess = function (clientId, petIds, bookingsResponseDto, masterData, timeZone) {
    return {
        type: BOOKINGS_FETCH_CLIENT_PENDINGS_SUCCESS_ACTION_TYPE,
        payload: {
            bookings: bookingsResponseDto.bookings_to_confirm.map(function (dto) {
                return convertToBooking(dto, masterData, timeZone);
            }),
            clientId: clientId,
            petIds: petIds,
        },
    };
};
var fetchClientWithStaffIssuesStart = function (clientId, petIds, requestUuid) {
    return {
        type: BOOKINGS_FETCH_CLIENT_WITH_STAFF_ISSUES_START_ACTION_TYPE,
        payload: {
            clientId: clientId,
            petIds: petIds,
            from: null,
            to: null,
            requestUuid: requestUuid,
        },
    };
};
var fetchClientWithStaffIssuesSuccess = function (clientId, petIds, bookingsResponseDto, masterData, timeZone) {
    return {
        type: BOOKINGS_FETCH_CLIENT_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE,
        payload: {
            bookings: bookingsResponseDto.bookings_to_check.map(function (dto) {
                return convertToBooking(dto, masterData, timeZone);
            }),
            clientId: clientId,
            petIds: petIds,
        },
    };
};
var getStart = function (context) {
    return {
        type: context === "invoice"
            ? BOOKINGS_GET_INVOICE_BOOKING_START_ACTION_TYPE
            : BOOKINGS_GET_START_ACTION_TYPE,
    };
};
var getSuccess = function (bookingDto, masterData, timeZone, context) {
    return {
        type: context === "invoice"
            ? BOOKINGS_GET_INVOICE_BOOKING_SUCCESS_ACTION_TYPE
            : BOOKINGS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            booking: convertToBooking(bookingDto, masterData, timeZone),
        },
    };
};
var confirmStart = function () {
    return {
        type: BOOKINGS_CONFIRM_START_ACTION_TYPE,
    };
};
var confirmSuccess = function (booking) {
    return {
        type: BOOKINGS_CONFIRM_SUCCESS_ACTION_TYPE,
        payload: {
            booking: booking,
        },
    };
};
var confirmAppointmentStart = function () {
    return {
        type: BOOKINGS_CONFIRM_APPOINTMENT_START_ACTION_TYPE,
    };
};
var confirmAppointmentSuccess = function (booking) {
    return {
        type: BOOKINGS_CONFIRM_APPOINTMENT_SUCCESS_ACTION_TYPE,
        payload: {
            booking: booking,
        },
    };
};
var cancelStart = function () {
    return {
        type: BOOKINGS_CANCEL_START_ACTION_TYPE,
    };
};
var cancelSuccess = function (booking) {
    return {
        type: BOOKINGS_CANCEL_SUCCESS_ACTION_TYPE,
        payload: {
            booking: booking,
        },
    };
};
var deleteStart = function (bookingId) {
    return {
        type: BOOKINGS_DELETE_START_ACTION_TYPE,
        payload: {
            bookingId: bookingId,
        },
    };
};
var deleteSuccess = function (bookingId) {
    return {
        type: BOOKINGS_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            bookingId: bookingId,
        },
    };
};
export var bookingAssignStaff = function (appointmentId, staff) {
    return {
        type: BOOKINGS_ASSIGN_STAFF_ACTION_TYPE,
        payload: {
            appointmentId: appointmentId,
            staff: staff,
        },
    };
};
var updateLocal = function (booking) {
    return {
        type: BOOKINGS_UPDATE_LOCAL_ACTION_TYPE,
        payload: {
            booking: booking,
        },
    };
};
var removeLocal = function (bookingId) {
    return {
        type: BOOKINGS_REMOVE_LOCAL_ACTION_TYPE,
        payload: {
            bookingId: bookingId,
        },
    };
};
var removeSeveralLocal = function (appointmentIds) {
    return {
        type: BOOKINGS_REMOVE_SEVERAL_LOCAL_ACTION_TYPE,
        payload: {
            appointmentIds: appointmentIds,
        },
    };
};
var cancelSeveralLocal = function (appointmentIds, canceledStatus) {
    return {
        type: BOOKINGS_CANCEL_SEVERAL_LOCAL_ACTION_TYPE,
        payload: {
            appointmentIds: appointmentIds,
            canceledStatus: canceledStatus,
        },
    };
};
var lockStart = function (bookingId) {
    return {
        type: BOOKINGS_LOCK_START_ACTION_TYPE,
        payload: {
            bookingId: bookingId,
        },
    };
};
var lockEnd = function (lock) {
    return {
        type: BOOKINGS_LOCK_END_ACTION_TYPE,
        payload: {
            lock: lock,
        },
    };
};
var unlockStart = function () {
    return {
        type: BOOKINGS_UNLOCK_START_ACTION_TYPE,
    };
};
var unlockEnd = function (bookingId) {
    return {
        type: BOOKINGS_UNLOCK_SUCCESS_ACTION_TYPE,
        payload: {
            bookingId: bookingId,
        },
    };
};
var unlockUnauthorized = function () {
    return {
        type: BOOKINGS_UNLOCK_UNAUTHORIZED_ACTION_TYPE,
    };
};
var error = function () {
    return {
        type: BOOKINGS_ERROR_ACTION_TYPE,
    };
};
